import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { OrganizationContentBlocksOrganism } from '../../organisms';
import { BlockItem } from '../../atoms/SortableImageBlockItem/SortableImageBlockItem';
import { BlockType } from '../../../store/landscapeAPI/block/dto/block-type';
import OrganizationBaseEditTemplate from '../../../templates/OrganizationBaseEditTemplate';

export interface OrganizationContentBlocksTemplateProps {
  blockItems: BlockItem[];
  setBlockItems: (items: BlockItem[], from: number, to: number) => void;
  changeOrderEnabled: boolean;
  setChangeOrderEnabled: (enabled: boolean) => void;
  handleDelete: (id: string) => void;
  handleEdit: (id: string, type: BlockType) => void;
}

const OrganizationContentBlocksTemplate: FC<
  OrganizationContentBlocksTemplateProps
> = ({
  blockItems,
  setBlockItems,
  changeOrderEnabled,
  setChangeOrderEnabled,
  handleDelete,
  handleEdit,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <OrganizationBaseEditTemplate>
          <OrganizationContentBlocksOrganism
            blockItems={blockItems}
            setBlockItems={setBlockItems}
            changeOrderEnabled={changeOrderEnabled}
            setChangeOrderEnabled={setChangeOrderEnabled}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
          />
        </OrganizationBaseEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default OrganizationContentBlocksTemplate;
